import axios from "../axios/axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSystemLanguage } from "../Redux/StudBook/StudBookSlice";
import TranslationText, { useTranslate } from "./TranslationText";
import BigLoader from "./BigLoader";
import { useLocation } from "react-router-dom";
import { onSnapshot, orderBy, query, where } from "firebase/firestore";
import { serviceRequest } from "../firebase/collections";
import { NightyNineMax } from "../helper/NightyNineMax";
import { FetchAddFollowUpthunk, FetchGetFollowUpDatathunk } from "../Redux/ServicesRequests/ServicesRequestsAction";
import axiosInstance from "../axios/axios";
import { formatDateTimeToString } from "../helper/formatDateTimeToString";
import EahsForm from "./EahsForm";
import FollowUpData from "./FollowUpData";
import NetaqInput from "./NetaqInput";
import PillBtn from "./PillBtn";
import HeadernderLine from "./HeadernderLine";
import CustomPopUp from "./CustomPopUp";
import DropDownDevider from "./DropDownDevider";
import { checkLiveEventubraco } from "./CheckLiveEventUmbraco/checkLiveEventUmbraco";
import RoutesName from "../RoutesName";
import AppBanner from "./AppBanner";
import './CustomCss/header.css'

const baseURL = process.env.REACT_APP_BASE_URL2;
const logoutUAEPASS = process.env.REACT_APP_UAE_PASS_LOGOUT_LINK;
const RedirectUAEPASS = process.env.REACT_APP_UAE_PASS_REDIRECT_LINK;
const isTestApp = process.env.REACT_APP_IS_TEST;


export default function Header({ agentOS }) {
  const menuRef = useRef();
  const [isNavVisible, setNavVisible] = useState(false);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [formPopUpChatModel, setFormPopUpChatModel] = useState({
    serviceId: "",
    serviceDefinitionName: "",
    referenceNumber: "",
  });
  const [streamingUrl, setStreamingUrl] = useState('');
  const [openChatPopup, setOpenChatPopup] = useState(false);


  const { translate } = useTranslate();

  // Handle overlay click
  const handleOverlayClick = () => {
    setNavVisible(!isNavVisible);
    setOverlayVisible(!isOverlayVisible);
  };

  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessTokenforEAHS")
  );

  const [currentTab, setCurrentTabState] = useState("home");

  function setCurrentTab(currentTab) {
    setCurrentTabState(currentTab);
  }

  // current tab
  const location = useLocation();

  const {
    followUpData
  } =
    useSelector((state) => state.servicesRequestsSlice);

  const [scrollValue, setScrollValue] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollValue(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setCurrentTab("home");
        break;
      case "/horseMarket":
        setCurrentTab("horse-market");
        break;
      case "/horseSupplies":
        setCurrentTab("horse-market");
        break;
      case "/HorseTransportCompanies":
        setCurrentTab("horse-market");
        break;
      case "/EquestrianCentersClubs":
        setCurrentTab("horse-market");
        break;
      case "/horsemarketprofile":
        setCurrentTab("horse-market");
        break;
      case "/SingleSupplier":
        setCurrentTab("horse-market");
        break;
      case "/SingleTransportCompany":
        setCurrentTab("horse-market");
        break;
      case "/SingleEquestrianCentersClubs":
        setCurrentTab("horse-market");
        break;
      case "/HorseHospitals":
        setCurrentTab("horse-market");
        break;
      case "/studbook":
        setCurrentTab("studbook");
        break;
      case "/horsedetails":
        setCurrentTab("studbook");
        break;
      case "/horseDetails":
        setCurrentTab("studbook");
        break;
      case "/services":
        setCurrentTab("services");
        break;
      case "/singleservice":
        setCurrentTab("services");
        break;
      case "/book-table":
        setCurrentTab("events");
        break;
      case "/opend-events":
        setCurrentTab("events");
        break;
      case "/opend-ads":
        setCurrentTab("events");
        break;
      case "/auctions":
        setCurrentTab("horse-market");
        break;
      case "/auction":
        setCurrentTab("horse-market");
        break;
      case "/hybridBidding":
        setCurrentTab("horse-market");
        break;
      case "/courseDetails":
        setCurrentTab("horse-market");
        break;
      case "/libraryPage":
        setCurrentTab("horse-market");
        break;
      case "/horse-auction":
        setCurrentTab("horse-market");
        break;
      case "/courseEnrollmentDate":
        setCurrentTab("horse-market");
        break;
      case "/courses":
        setCurrentTab("horse-market");
        break;
      case "/Educational-Courses":
        setCurrentTab("horse-market");
        break;
      case "/courses":
        setCurrentTab("events");
        break;
      case "/Educational-Courses":
        setCurrentTab("events");
        break;
      case "/waho-trophy":
        setCurrentTab("events");
        break;
      case "/eahs-award":
        setCurrentTab("events");
        break;
      case "/bidding":
        setCurrentTab("events");
        break;
      case "/shows":
        setCurrentTab("events");
        break;
      case "/showdetails":
        setCurrentTab("events");
        break;
      case "/calendar":
        setCurrentTab("events");
        break;
      case "/shows-categories":
        setCurrentTab("events");
        break;
      case "/news":
        setCurrentTab("Media-Center");
        break;
      case "/gallery":
        setCurrentTab("Media-Center");
        break;
      case "/singlePost":
        setCurrentTab("Media-Center");
        break;
      case "/about-us":
        setCurrentTab("about-us");
        break;
      case "/orgChart":
        setCurrentTab("about-us");
        break;
      case "/contactus":
        setCurrentTab("contact-us");
        break;

      default:
        setCurrentTab("");
        break;
    }
    if (windowWidtht <= 991) {
      const collapseInstance = new window.bootstrap.Collapse(menuRef.current, {
        toggle: false
      });
      collapseInstance.hide();
    }
  }, [location]);


  const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
  const [userProfile, setUserProfile] = useState("");
  const [showAccountList, setShowAccountList] = useState(false);
  const [showBigLoader, setShowBigLoader] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLanguageChange = (lang) => {
    setShowBigLoader(true);
    dispatch(setSystemLanguage(lang));
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(window.location.search);
    const haseahsLang = searchParams.has("eahsLang")
      ? true
      : false;
    if (haseahsLang) {
      url.searchParams.delete('eahsLang');
      window.history.replaceState({}, '', url.toString());
    }
    setTimeout(() => {
      setShowBigLoader(false);
      window.location.reload();
    }, 1000);
  };



  const {
    setCurrentSubAccountId
  } = useSelector((state) => state.ownerProfileSlice);


  useEffect(() => {
    // Check if access token is stored in localStorage
    const accessToken = localStorage.getItem("accessTokenforEAHS");

    if (accessToken) {
      setAccessToken(accessToken);
      // console.log("This is token in cookies", accessToken);
    }

    if (accessToken) {
      async function getUserProfile(accessToken) {
        const userProfile = await axios.get("/account/profile", {
          skipOwnerHeader: true
        });

        if (userProfile.data.status.detailedResponseCode !== "Success") {
          debugger;
          handlelogout(userProfile);
          return <Navigate to="/login" />;
        } else {
          localStorage.setItem("EAHSUserID", userProfile.data.result.id);

          localStorage.setItem(
            "EAHSUserFullName",
            userProfile.data.result.fullName
          );
          const jsonString = JSON.stringify(userProfile.data.result);
          localStorage.setItem("eahsUserProfile", jsonString);
          //localStorage.setItem("currentSubAccountId",userProfile.data.result.id);
          localStorage.setItem("EAHSUserID", userProfile.data.result.id);
        }
        setUserProfile(userProfile.data.result);
      }
      getUserProfile(accessToken);
      // console.log("userProfile is loaded", userProfile);
    }
  }, [accessToken, navigate]);

  async function lougoutUaePass() {
    try {
      window.location.href = `${logoutUAEPASS}?redirect_uri=${RedirectUAEPASS}`;

      localStorage.setItem("EAHSUserIsUAEPASSUser", false);
    } catch (error) {
      console.log("error in logout in UAE PASS", error);
    }
  }

  async function handlelogout(userProfile) {
    debugger;
    localStorage.clear();
    await setUserProfile("");
    if (isTestApp == "false") {
      await lougoutUaePass();
    }
    if (userProfile !== "") {
      navigate("/login", { state: "loggedout" });
    } else {
      navigate("/login", { state: "gotologin" });
    }
  }

  const ref = useRef(null);
  const handleClickOutside = useCallback((event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      // Handle click outside the element (e.g., close a menu, etc.)
      setShowAccountList(false);
    }
  }, [ref]);


  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidtht, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, [handleClickOutside]);

  const [firestoreData, setFireStoreData] = useState([]);

  const filterCollection = async () => {
    const q = query(serviceRequest,
      where("Flag", "==", false),
      where("UserIds", "array-contains", setCurrentSubAccountId),
      orderBy('TimeStamp', 'desc'));
    return q;
  };



  const [showNotificationPanel, setShowNotificationPanel] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = await filterCollection();
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const newData = [];

          querySnapshot.forEach((doc) => {
            newData.push(doc.data());
          });
          let resultLowercaseKeys = newData
            .map((obj) => {
              return Object.keys(obj).reduce((acc, key) => {
                acc[key.toLowerCase()] = obj[key];
                return acc;
              }, {});
            });
          setFireStoreData(resultLowercaseKeys);

          console.log("newData is", resultLowercaseKeys);
          // }
        });

        return unsubscribe;
      } catch (error) {
        console.error("Error fetching data in Header:", error);
      }
    };
    if (!!accessToken) {
      fetchData();
    }
  }, [accessToken, setCurrentSubAccountId]);


  // live Show Check
  const [liveShowId, setLiveShowID] = useState(null);
  const [liveEventType, setLiveEventType] = useState('showdetails?id');
  async function CheckRunningShows() {
    try {
      checkLiveEventubraco().then((res) => {
        if (res?.isActive == true) {
          setStreamingUrl(res?.streamingUrl)
        }
      });
      const response = await axiosInstance.get('shows/checkliveevent');
      if (response.data.responseCode == "200") {
        if (response.data.result.eventType.toLowerCase() == 'auction') {
          setLiveEventType('hybridBidding?auctionID');
        }
        if (response.data.result.eventType.toLowerCase() == 'show') {
          setLiveEventType('showdetails?id');
        }
        if (response.data.result && !!response.data.result.liveLink) {
          setLiveShowID(response.data.result.id)
        }
      }

    } catch (error) {
      console.error('error in getting live Shows', error);
    }
  }

  useEffect(() => {
    CheckRunningShows();
  }, [])
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (showBigLoader) {
    return <BigLoader />;
  }



  //show notification panel
  const togglePanel = () => {
    setShowNotificationPanel(!showNotificationPanel);
  };


  const handleNotificationClick = (link) => {
    togglePanel();

    navigate(link);
  };


  const handelClickIsChatAction = (e, item) => {
    e.preventDefault();

    togglePanel();

    setFormPopUpChatModel({
      ...formPopUpChatModel,
      serviceId: item.serviceid,
      serviceDefinitionName: currentLanguage === "en" ? item.servicename : item.servicenamear,
      referenceNumber: item.referencenumber,
    });

    let params = {
      serviceId: item.serviceid,
      type: "Notifi",
    };

    dispatch(FetchGetFollowUpDatathunk(params));

    setTimeout(() => {
      setOpenChatPopup((o) => !o);
    }, 500);
  }

  const handelAddFollowUp = () => {
    if (formPopUpChatModel?.chat?.trim() !== "") {

      let params = {
        ownerId: localStorage.getItem("currentSubAccountId"),
        serviceId: formPopUpChatModel.serviceId,
        comment: formPopUpChatModel.chat,
      }

      setFormPopUpChatModel({
        ...formPopUpChatModel,
        chat: "",
        errorChat: false
      });

      dispatch(FetchAddFollowUpthunk(params));

      let paramsFollowUpData = {
        serviceId: formPopUpChatModel.serviceId,
        type: "Notifi",
      };

      setTimeout(() => {
        dispatch(FetchGetFollowUpDatathunk(paramsFollowUpData));
      }, 500);
    }
    else {
      setFormPopUpChatModel({
        ...formPopUpChatModel,
        errorChat: true
      });
    }
  };

  const marginValue = 25;
  const fontSizeNav = 13;




  const scrolledStyle = { background: 'var(--white)', position: 'fixed', top: 0, zIndex: 4800, width: '100%' };
  const firstStyle = { background: 'var(--white)' }

  return (
    <>
      <AppBanner agentOS={agentOS} />
      <div style={scrollValue > 100 ? scrolledStyle : firstStyle}>
        <div className="container bold position-relative  " style={{ paddingTop: 20 }}>
          {(windowWidtht > 991) && <>
            <div className="row  me-0  rtl" style={{ paddingBottom: 20, marginBottom: 5 }}>
              <Link to={'/'} className="col-lg-2 col-md-3 col-sm-6 col-12 " style={{ width: 223 }}>
                <img src={`${baseURL}/assets/img/EAHSlogo.svg`} className="w-100" alt="logo" />
              </Link>
              {streamingUrl != "false" && streamingUrl != "" && (
                <>
                  <PillBtn
                    isFirstPill={windowWidtht > 425}
                    routeName={`/live-event`}
                    text={
                      <>
                        <div className="redpointLive me-2" />
                        {translate("web.liveBrodcast", "Live")}
                      </>}
                  />
                </>
              )}
              {!!liveShowId &&
                <>
                  <PillBtn
                    isFirstPill={windowWidtht > 425}
                    routeName={`/${liveEventType}=${liveShowId}`}
                    text={
                      <>
                        <div className="redpointLive me-2" />
                        {translate("web.liveBrodcast", "Live")}
                      </>}
                  />
                </>
              }

              <PillBtn
                isFirstPill={(!!liveShowId || (streamingUrl != "false" && streamingUrl != "")) ? false : windowWidtht > 425}
                isExternal={true}
                routeName={"https://eahgc.ae/"}
                text={translate("web.emiratesCup", "Emirates Cup")}
                imgURL="/assets/img/ecup.png"

              />
              {!userProfile &&
                <PillBtn
                  isRed={true}
                  isLastPill={true}
                  routeName={"/login"}
                  text={translate("web.login", "Login")} />
              }
              {!!userProfile &&
                <PillBtn
                  isRed={true}
                  isLastPill={true}
                  isWithClass={true}
                  isDropDown
                  handlelogout={handlelogout}
                  translate={translate}
                  classes="btn-danger"
                  text={translate('web.profile', 'Profile')}
                />}
            </div>

            <hr className="dropdown-divider my-0" />
          </>}

          <nav className="navbar navbar-expand-lg navbar-light  rtl">
            <div className="container-fluid px-0">
              {windowWidtht <= 991 &&
                <Link to={'/'} className="navbar-brand" style={{ width: 223 }}>
                  <img src={`${baseURL}/assets/img/EAHSlogo.svg`} className="w-100" alt="logo" />
                </Link>
              }
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" ref={menuRef} id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  {windowWidtht <= 991 &&
                    <>
                      <div className="my-1">
                        {streamingUrl != "false" && streamingUrl != "" && (
                          <>
                            <PillBtn
                              isFirstPill={false}
                              routeName={`/live-event`}
                              text={
                                <>
                                  <div className="redpointLive me-2" />
                                  {translate("web.liveBrodcast", "Live")}
                                </>}
                            />
                          </>
                        )}
                      </div>
                      <div className="my-1">
                        {!!liveShowId &&
                          <>
                            <PillBtn
                              isFirstPill={false}
                              routeName={`/${liveEventType}=${liveShowId}`}
                              text={
                                <>
                                  <div className="redpointLive me-2" />
                                  {translate("web.liveBrodcast", "Live")}
                                </>}
                            />
                          </>
                        }
                      </div>
                      {/* <div className="my-1">
                        <PillBtn
                          isFirstPill={false}
                          isExternal={true}
                          imgURL="/assets/img/wahoLogo.png"
                          routeName={"/wahoconference"}
                          text={translate("web.wahoConference", "Waho Conference")}
                        />
                      </div> */}
                      <div className="my-1">
                        <PillBtn
                          routeName={"https://eahgc.ae/"}
                          text={translate("web.emiratesCup", "Emirates Cup")}
                          imgURL="/assets/img/ecup.png"

                        />
                      </div>
                      {!userProfile &&
                        <div className="my-1">
                          <PillBtn
                            isRed={true}
                            isLastPill={true}
                            routeName={"/login"}
                            text={translate("web.login", "Login")} />
                        </div>
                      }
                      {!!userProfile &&
                        <div className="dropdown my-1 px-1" >
                          <button className="btn btn-danger  rounded-pill border-0  w-100" style={currentLanguage == 'en' ? { paddingLeft: 23, paddingRight: 23 } : { paddingLeft: 23, paddingRight: 23, height: 32, lineHeight: '15px' }} type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            {translate('web.profile', 'Profile')}
                          </button>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li>
                              <Link to={'/profile'} className="dropdown-item" >
                                {translate('web.accountSettings', 'Account Setting')}
                              </Link>
                            </li>
                            <li><button onClick={handlelogout} className="dropdown-item" > {translate('web.logout', 'Logout')}
                            </button></li>
                          </ul>
                        </div>
                      }
                    </>}
                  <li className="nav-item ">
                    <Link to={"/"} className={`nav-link ps-0 fw-bold  active `} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} aria-current="page">
                      <TranslationText defaultText={"Home"} textkey={"web.home"} />
                      <HeadernderLine currentTab={currentTab} target={'home'} key={'home'} />
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link className={`nav-link ps-0 fw-bold  active dropdown-toggle`} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} href="#" id="navbarDropdownServices" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <TranslationText
                        defaultText={"Services"}
                        textkey={"web.services"}
                      />
                    </Link>
                    <HeadernderLine currentTab={currentTab} target={'services'} key={'services'} isDropDown={true} />
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdownServices">
                      <li>
                        <Link
                          to={"/services"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Services"}
                            textkey={"web.services"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"http://www.waho.org"}
                          target="_blank"
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"WAHO rules"}
                            textkey={"web.wahoRules"}
                          />
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <Link className={`nav-link ps-0 fw-bold  active dropdown-toggle`} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <TranslationText
                        defaultText={"Studbook"}
                        textkey={"web.studBook"}
                      />
                    </Link>
                    <HeadernderLine currentTab={currentTab} target={'studbook'} key={'studbook'} isDropDown={true} />
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <Link
                          to={"/studbook"}
                          className="dropdown-item"
                        >
                          <img src={`${baseURL}/assets/img/AE.png`} className="me-2" style={{ width: 30 }} alt="UAE" />
                          <TranslationText
                            defaultText={"UAE Studbook"}
                            textkey={"web.uaestudBook"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link to={"https://vzap.org/zb-online/"} target="_blank" className="dropdown-item">
                          <img src={`${baseURL}/assets/img/DE.png`} className="me-2" style={{ width: 30 }} alt="UAE" />
                          <TranslationText
                            defaultText={"VZAP studbook (German Studbook)"}
                            textkey={"web.vzapStudbook"}
                          />
                        </Link>
                      </li>

                    </ul>

                  </li>
                  <li className="nav-item dropdown">
                    <Link className={`nav-link ps-0 fw-bold  active dropdown-toggle`} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <TranslationText
                        defaultText={"Owner Services"}
                        textkey={"web.ownerServices"}
                      />
                    </Link>
                    <HeadernderLine currentTab={currentTab} target={'horse-market'} isDropDown={true} key={'horse-market'} />
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <>
                        <li>
                          <Link
                            to={"/auctions"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Auctions"}
                              textkey={"web.horsesAuctions"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>

                        {isTestApp == 'true' &&
                          <li>
                            <Link
                              to={"/semenMarket"}
                              className="dropdown-item"
                            >
                              <TranslationText
                                defaultText={"Semen Market"}
                                textkey={"web.semenMarket"}
                              />
                            </Link>
                            <DropDownDevider />
                          </li>
                        }
                        <li>
                          <Link
                            to={"/courses"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Courses"}
                              textkey={"web.courses"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/Educational-Courses"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Educational"}
                              textkey={"web.educational"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/libraryPage"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"EAHS Library"}
                              textkey={"web.eahsLibrary"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                      </>
                      <li>
                        <Link
                          to={"/horseSupplies"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Horse Supplies"}
                            textkey={"web.horseSupplies"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/HorseTransportCompanies"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Horse Transport Companies"}
                            textkey={"web.horseTransportCompanies"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/EquestrianCentersClubs"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Equestrian Centers Clubs"}
                            textkey={"web.equestrianCentersClubs"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/HorseHospitals"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Horse Hospitals"}
                            textkey={"web.horseHospitals"}
                          />
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <>
                    {currentLanguage == 'ar' &&
                      <style>
                        {`.dropend .dropdown-toggle::after{
                      vertical-align: .255em !important;
                      margin-left:unset  !important;
                      margin-right:10px  !important;
                      }`}
                      </style>
                    }
                    <li class="nav-item dropdown">
                      <a class="nav-link ps-0 fw-bold dropdown-toggle"
                        style={{ color: "#000", fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }}
                        href="#" role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                        <TranslationText
                          defaultText={"Events And Activities"}
                          textkey={"web.eventsAndActivities"}
                        />
                      </a>
                      <HeadernderLine currentTab={currentTab} target={'events'} isDropDown={true} key={'events'} />
                      <ul class="dropdown-menu">
                        <li>
                          <Link
                            to={"/calendar"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Calender"}
                              textkey={"web.calender"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/shows"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Shows"}
                              textkey={"web.shows"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/eahs-award"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"EAHS Award"}
                              textkey={"web.eahsAward"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/opend-ads"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Book Table"}
                              textkey={"web.bookTable"}
                            />
                            {/* <TranslationText
                            defaultText={"Advertis Package"}
                            textkey={"web.advertisPackage"}
                          /> */}
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={"/opend-events"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Advertis Package"}
                              textkey={"web.advertisPackage"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>

                        <li>
                          <Link
                            to={"/waho-trophy"}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"Waho Trophy"}
                              textkey={"web.wahoTrophy"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li>
                          <Link
                            to={RoutesName.UAEOfficials}
                            className="dropdown-item"
                          >
                            <TranslationText
                              defaultText={"UAE Officials"}
                              textkey={"web.uaeOfficials"}
                            />
                          </Link>
                          <DropDownDevider />
                        </li>
                        <li class="dropend">
                          <a class="dropdown-item dropdown-toggle" href="#" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                            <TranslationText
                              defaultText={"Show Rules and Categories"}
                              textkey={"web.showRulesandCategories"}
                            />
                          </a>
                          <ul class="dropdown-menu dropdown-menu-end">
                            <li> <Link
                              to={"/shows-categories"}
                              className="dropdown-item"
                            >
                              <TranslationText
                                defaultText={"Shows Categories"}
                                textkey={"web.showsCategories"}
                              />
                            </Link>
                              <DropDownDevider />
                            </li>
                            <li>
                              <Link
                                to={"https://www.ecaho.org/shows/blue-book"}
                                target="_blank"
                                className="dropdown-item"
                              >
                                <TranslationText
                                  defaultText={"ECAHO Shows Rules"}
                                  textkey={"web.ecahoShowsRules"}
                                />
                              </Link>
                              <DropDownDevider />
                            </li>
                            <li>
                              <Link
                                to={RoutesName.NONE_ECAHO_SHOWS_CATEGORIES}
                                className="dropdown-item"
                              >
                                <TranslationText
                                  defaultText={"None ECAHO Shows Categories"}
                                  textkey={"web.noneEcahoShowsCategories"}
                                />
                              </Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </>

                  <li className="nav-item dropdown">
                    <Link className={`nav-link ps-0 fw-bold  active dropdown-toggle`} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <TranslationText
                        defaultText={"Media Center"}
                        textkey={"web.mediaCenter"}
                      />
                    </Link>
                    <HeadernderLine currentTab={currentTab} target={'Media-Center'} isDropDown={true} key={'Media-Center'} />
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <Link
                          to={"/news"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"News"}
                            textkey={"web.news"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/gallery"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Gallery"}
                            textkey={"web.gallery"}
                          />
                        </Link>
                      </li>
                    </ul>
                  </li>

                  <li className="nav-item dropdown">
                    <Link className={`nav-link ps-0 fw-bold  active dropdown-toggle`} style={{ fontSize: fontSizeNav, marginLeft: currentLanguage == 'ar' ? marginValue : 'unset', marginRight: currentLanguage == 'en' ? marginValue : 'unset' }} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <TranslationText
                        defaultText={"About Us"}
                        textkey={"web.aboutUs"}
                      />
                    </Link>
                    <HeadernderLine currentTab={currentTab} target={'about-us'} isDropDown={true} key={'about-us'} />
                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <Link
                          to={"/about-us"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"About Us"}
                            textkey={"web.aboutUs"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/PresidentWord"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"General Manager Word"}
                            textkey={"web.generalManegerWord"}
                          />
                        </Link>
                        <DropDownDevider />
                      </li>
                      <li>
                        <Link
                          to={"/orgChart"}
                          className="dropdown-item"
                        >
                          <TranslationText
                            defaultText={"Org Chart"}
                            textkey={"web.orgChart"}
                          />
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item">
                    <Link to={"/contactus"} className={`nav-link ps-0 fw-bold  active`} style={{ fontSize: fontSizeNav }} aria-current="page">
                      <TranslationText
                        defaultText={"Contact Us"}
                        textkey={"web.contactUs"}
                      />
                      <HeadernderLine currentTab={currentTab} target={'contact-us'} key={'contact-us'} />
                    </Link>
                  </li>

                  {windowWidtht <= 992 &&
                    <li className="nav-item">
                      {currentLanguage == "en" ?
                        <Link to={"/"} onClick={() => handleLanguageChange("ar")} className={`nav-link ps-0 fw-bold  active`} style={{ fontSize: fontSizeNav }} aria-current="page">
                          <TranslationText defaultText={"AR"} textkey={"web.ar"} />

                        </Link>
                        : <Link to={"/"} onClick={() => handleLanguageChange("en")} className={`nav-link ps-0 fw-bold  active`} style={{ fontSize: fontSizeNav }} aria-current="page">
                          <TranslationText defaultText={"EN"} textkey={"web.en"} />
                        </Link>
                      }
                    </li>
                  }
                </ul>
                {firestoreData?.length > 0 &&
                  <>
                    <div className="d-flex rtl">
                      <button
                        className="nav-item active text-dark bgtransparent-outline-0-border-0 bellDiv me-3"
                        type="button"
                        style={{ marginTop: -10 }}
                        onClick={togglePanel}
                      >
                        <i className=" fa-regular fa-bell fa-lg"></i>
                        <span className="badgebell">
                          {NightyNineMax(firestoreData?.length ?? 0)}
                        </span>
                      </button>
                    </div>
                  </>
                }

                {windowWidtht > 991 &&
                  <>
                    {currentLanguage == "en" ? (
                      <div className="bold" style={{ marginTop: -15 }}>
                        <button
                          className=" bgtransparent-outline-0-border-0 nav-item"
                          type="button"
                          data-toggle="dropdown"
                          id="langbtn"
                          onClick={() => handleLanguageChange("ar")}
                          style={{ fontFamily: 'Cario', fontSize: 12, marginTop: -10, fontWeight: 'bold' }}
                        >
                          <TranslationText defaultText={"AR"} textkey={"web.ar"} />
                        </button>
                      </div>
                    ) : (
                      <div className="bold" style={{ marginTop: -10 }}>

                        <button
                          className="bgtransparent-outline-0-border-0 nav-item"
                          type="button"
                          data-toggle="dropdown"
                          id="langbtn"
                          onClick={() => handleLanguageChange("en")}
                          style={{ fontSize: 12, fontWeight: 'bold' }}


                        >
                          <TranslationText defaultText={"EN"} textkey={"web.en"} />
                        </button>
                      </div>
                    )}
                  </>
                }
              </div>
            </div>
          </nav>


          {/* <div id="menu_btn" onClick={handleMenuClick}>
          <i className=" fa-solid fa-bars font-50"></i>
        </div> */}
          {!!firestoreData && (
            <>
              {/* notification panel */}
              <div
                className={`panel ${showNotificationPanel ? "show" : ""} `}
                style={{ paddingTop: 25 }}
              >
                <div className="bold closeButn" onClick={togglePanel}>
                  X
                </div>

                <div className="notifications rtl">
                  <h2>
                    {" "}
                    <TranslationText
                      defaultText={"Notifications"}
                      textkey={"web.notifications"}
                    />
                  </h2>
                  {!!firestoreData &&
                    firestoreData.map((item, i) => (
                      <div className="notification-item" key={i}>

                        {item.url !== "" && (
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNotificationClick(
                                item.url
                              );
                            }}
                          >
                            <i className="fa-regular fa-envelope"></i>
                            <span className="px-3">
                              {
                                item.referencenumber
                              }
                            </span>
                            <div className="d-flex justify-content-between align-items-center px-3">
                              <p className="mb-0">
                                {currentLanguage === "en"
                                  ? item.statusen
                                  : item.statusar}
                              </p>
                              {item.timestamp && (
                                <p className="font-10 text-muted mb-0">
                                  {formatDateTimeToString(new Date(item.timestamp.seconds * 1000), currentLanguage, true)}
                                </p>
                              )}
                            </div>
                          </Link>
                        )}

                        {item.url === "" && (
                          <>
                            <i className="fa-regular fa-envelope" style={{ padding: 10 }}></i>
                            <span className="px-3">
                              {
                                item.referencenumber
                              }
                            </span>
                            <div className="d-flex justify-content-between align-items-center px-3">
                              <p className="mb-0">
                                {currentLanguage === "en"
                                  ? item.statusen
                                  : item.statusar}
                              </p>
                              {item.timestamp && (
                                <p className="font-10 text-muted mb-0">
                                  {formatDateTimeToString(new Date(item.timestamp.seconds * 1000), currentLanguage, true)}
                                </p>
                              )}
                            </div>
                          </>
                        )}

                        {item.statusen === "Message" && (
                          <div className="row rtl">
                            <Link onClick={(e) => handelClickIsChatAction(e, item)}>
                              <i
                                className="fas fa-comment-dots"
                                title={translate(
                                  "web.followUp",
                                  "Follow Up"
                                )}
                              ></i>
                            </Link>
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </>
          )}

          {isOverlayVisible && (
            <div
              className={`panel ${showNotificationPanel ? "show" : ""} `}
              style={{ paddingTop: 25 }}
            >
              <div className="bold closeButn" onClick={togglePanel}>
                X
              </div>
              <div className="notifications rtl">
                <h2>
                  {" "}
                  <TranslationText
                    defaultText={"Notifications"}
                    textkey={"web.notifications"}
                  />
                </h2>
                {!!firestoreData &&
                  firestoreData.map((item, i) => (
                    <div className="notification-item" key={i}>
                      {item.url !== "" && (
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNotificationClick(
                              item.url
                            );
                          }}
                        >
                          <i className="fa-regular fa-envelope"></i>
                          <span className="px-3">
                            {
                              item.referencenumber
                            }
                          </span>
                          <div className="d-flex justify-content-between align-items-center px-3">
                            <p className="mb-0">
                              {currentLanguage === "en"
                                ? item.statusen
                                : item.statusar}
                            </p>
                            {item.timestamp && (
                              <p className="font-10 text-muted mb-0">
                                {formatDateTimeToString(new Date(item.timestamp.seconds * 1000), currentLanguage, true)}
                              </p>
                            )}
                          </div>
                        </Link>
                      )}

                      {item.url === "" && (
                        <>
                          <i className="fa-regular fa-envelope" style={{ padding: 10 }}></i>
                          <span className="px-3">
                            {
                              item.referencenumber
                            }
                          </span>
                          <div className="d-flex justify-content-between align-items-center px-3">
                            <p className="mb-0">
                              {currentLanguage === "en"
                                ? item.statusen
                                : item.statusar}
                            </p>
                            {item.timestamp && (
                              <p className="font-10 text-muted mb-0">
                                {formatDateTimeToString(new Date(item.timestamp.seconds * 1000), currentLanguage, true)}
                              </p>
                            )}
                          </div>
                        </>
                      )}

                      {item.statusen === "Message" && (
                        <div className="row rtl">
                          <Link
                            onClick={(e) => handelClickIsChatAction(e, item)}
                          >
                            <i
                              className="fas fa-comment-dots"
                              title={translate(
                                "web.followUp",
                                "Follow Up"
                              )}
                            ></i>
                          </Link>
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          )}

          {isOverlayVisible && (
            <div
              className="overlayMenu"
              style={{ display: "block" }}
              onClick={handleOverlayClick}
            ></div>
          )}

          {/*chat Service Request pop up */}
          <CustomPopUp
            title={formPopUpChatModel.serviceDefinitionName}
            open={openChatPopup}
            btnText={translate("web.send", "Send")}
            onClick={() => handelAddFollowUp()}

            content={<>
              <div className="col-md-12 col-sm-12 mb-4">
                <h3 className="fontWeight display-inline">
                  {`${formPopUpChatModel.serviceDefinitionName} `}
                </h3>
                <h4 className="fontWeight display-inline" style={{ marginLeft: 10, marginRight: 10 }}>
                  {formPopUpChatModel.referenceNumber}{" "}
                </h4>
              </div>

              <EahsForm title={translate("web.followUpMessages", "FollowUp Messages")} style={{ maxHeight: windowHeight * 0.2, overflowY: "auto" }} className="judgesList">
                <FollowUpData data={followUpData} key={'web.followUpData'} />
              </EahsForm>

              <div className="mt-5" style={{ maxHeight: windowHeight * 0.2, }}>
                <NetaqInput
                  label={translate("web.message", "Message")}
                  name={"chat"}
                  type={"textarea"}
                  hideLable={true}
                  maxchars={1150}
                  onChange={(e) => {
                    setFormPopUpChatModel({
                      ...formPopUpChatModel,
                      chat: e.target.value,
                    });
                  }}
                  value={formPopUpChatModel.chat}
                  placeholder={translate("web.addYourMessage", "Add Your Message...")}
                  textAreaHeight={`${windowHeight * 0.1}px`}
                />
                {formPopUpChatModel.errorChat && (
                  <p style={{ color: "red" }}>
                    {translate("web.requiredField", "Required Field")}
                  </p>
                )}
              </div>
            </>}
          />

        </div>
      </div>
    </>

  );
}


